import { render, staticRenderFns } from "./OrderShipUpdate.vue?vue&type=template&id=2b9b32f8&"
import script from "./OrderShipUpdate.vue?vue&type=script&lang=js&"
export * from "./OrderShipUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports